export const getLogisticProviderIntegrationsRoutes = () => {
    return [
        {
            path: '/logistic-management/integrations/',
            lazy: () =>
                import('../../pages/integrations/List').then((module) => ({ Component: module.IntegrationsList })),
        },
    ];
};
